<template>
    <div>
        <div class="mr-3">
          <button class="btn btn-file btn-outline-primary"
                  :disabled="readOnly">
            <b-icon-cloud-arrow-up></b-icon-cloud-arrow-up>
            <input name="excel"
                  type="file" ref="excelInput"
                  v-stream:change="onLoad$"
                  :disabled="readOnly">
              {{ loading ? 'Loading...' : '載入Excel檔' }}
          </button>
          <a target="_blank"
             class="example"
             href="/res/agc/excelExample.xlsx">Example
          </a>
        </div>
    </div>
</template>

<script>
import { from } from 'rxjs';
import {
  catchError,
  pluck,
  switchMap,
  tap,
  map,
} from 'rxjs/operators';
import {
  BIconCloudArrowUp,
} from 'bootstrap-vue';
import readXlsxFile from 'read-excel-file';
import vModelMixin from '../mixins/v-model';

export default {
  name: 'ExcelLoader',
  mixins: [vModelMixin],
  components: {
    BIconCloudArrowUp,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    validateRegEx: RegExp,
  },
  data() {
    return {
      loading: false,
    };
  },
  domStreams: ['onLoad$'],
  subscriptions() {
    const readExcel$ = this.onLoad$
      .pipe(
        tap(() => {
          this.loading = true;
        }),
        pluck('event', 'target', 'files', 0),
        switchMap((file) => from(readXlsxFile(file, {
          transformData: (data) => {
            if (this.validateRegEx) {
              return data.filter((row) => this.validateRegEx.test(row[0]));
            }
            return data;
          },
        }))),
        map((result) => result.map(([code]) => code)),
        tap((result) => {
          this.$emit('result', result);
          this.$refs.excelInput.value = '';
          this.loading = false;
        }),
        catchError(() => {
          this.$refs.excelInput.value = '';
          this.loading = false;
          this.$emit('error', '請選擇正確格式的 Excel 檔案');
          return readExcel$;
        }),
      );
    return {
      readExcel: readExcel$,
    };
  },
};
</script>

<style scoped lang="scss">
  .btn-file {
    position: relative;
    overflow: hidden;
    font-size: 14px;
    padding: 10px 16px;
    border: 1px solid #b1d7fb;
    background-color: #E0EFFD;

    .b-icon.bi {
      font-size: 140% !important;
      margin-right: 2px;
      padding-top: 2px;
    }

      & input[type=file] {
        position: absolute;
        top: 0;
        right: 0;
        min-width: 100%;
        min-height: 100%;
        font-size: 100px;
        text-align: right;
        filter: alpha(opacity=0);
        opacity: 0;
        outline: none;
        cursor: inherit;
        display: block;
      }
  }

  .example{
    text-decoration: underline;
    margin-left:10px;
    color:#000;
    font-size:0.85em;
  }
</style>
